import { useQuery } from '@tanstack/react-query';

import { fetchProjects } from '@/modules/projects/services/projects.service';

export function useProjects() {
  return useQuery({
    queryKey: ['projects'],
    queryFn: fetchProjects,
    // Conteúdo institucional muda pouco; não vale refazer a consulta a cada
    // volta de foco.
    staleTime: 5 * 60_000,
  });
}
